import React, { Component } from 'react';
import { getIcon, isEmpty } from '../../Common/Common';
import communication_error_icon from '../../../Images/Daikin_Images/image/CommError.png';
import device_error_icon from '../../../Images/Daikin_Images/image/Error.png';
import filter_icon from '../../../Images/Daikin_Images/image/Filtersign.png';
import off_timer_icon from '../../../Images/Daikin_Images/image/Offtimer.png';
import ch_master_icon from '../../../Images/Cell_Status_Icon/CHmaster/chmaster.png';
import batt from '../../../Images/Daikin_Images/image/Battery.png';
import zbatt0 from '../../../Images/Daikin_Images/image/zBattery0.png';
import zbatt20 from '../../../Images/Daikin_Images/image/zBattery20-1.png';
import zbatt50 from '../../../Images/Daikin_Images/image/zBattery50-21.png';
import zbatt80 from '../../../Images/Daikin_Images/image/zBattery80-51.png';
import zbatt100 from '../../../Images/Daikin_Images/image/zBattery100-81.png';

export default class Display_Mp_Cell_Icon extends Component {
	constructor(props) {
		super(props);

		this.isDeviceOn = false;
		this.displayDeviceErrorIcon = false;
		this.displayCommunicationErrorIcon = false;
		this.displayFilterSignIcon = false;
		this.displayCoolHeatMasterIcon = false;
		this.displayOffTimerIcon = false;
		this.batteryLevelValue = null;

		this.state = {}
	}

	handleCheckDeviceStatus = () => {
		let isDeviceOnTemp = false;
		let displayDeviceErrorIconTemp = false;
		let displayCommunicationErrorIconTemp = false;
		let displayFilterSignIconTemp = false;
		let displayCoolHeatMasterIconTemp = false;
		let displayOffTimerIconTemp = false;
		let batteryLevelValueTemp = null;
		let point_info = this.props.point_info;

		if (!isEmpty(point_info)) {
			if (point_info.hasOwnProperty('comm_stat')) {
				let communication_status = point_info.comm_stat;
				if (communication_status) {
					if (point_info.hasOwnProperty('stat')) {
						let mpStatus = point_info.stat;
						if (mpStatus === 'on') {
							isDeviceOnTemp = true;
						}
					}
				} else {
					displayCommunicationErrorIconTemp = true;
				}
			}

			if (point_info.hasOwnProperty('error')) {
				let deviceError = point_info.error;
				for (var key in deviceError) {
					if (deviceError[key]) {
						displayDeviceErrorIconTemp = true;
					}
				}
			}

			if (point_info.hasOwnProperty('filter')) {
				if (point_info.filter == 'on') {
					displayFilterSignIconTemp = true;
				}
			}

			if (point_info.hasOwnProperty('ch_master')) {
				if (point_info.ch_master == true || point_info.ch_master == 'true') {
					displayCoolHeatMasterIconTemp = true;
				}
			}

			if (point_info.hasOwnProperty('off_timer')) {
				if (point_info.off_timer == 'on') {
					displayOffTimerIconTemp = true;
				}
			}

			if (point_info.hasOwnProperty('bat')) {
				let batt = point_info.bat;

				if (batt != null) {
					switch (true) {
						case (batt == 0):
							batteryLevelValueTemp = zbatt0;
							break;
						case (batt <= 20):
							batteryLevelValueTemp = zbatt20;
							break;
						case (batt <= 50):
							batteryLevelValueTemp = zbatt50;
							break;
						case (batt <= 80):
							batteryLevelValueTemp = zbatt80;
							break;
						default:
							batteryLevelValueTemp = zbatt100;
					}
					//batteryLevelValueTemp = point_info.bat + '%';
				}
			}
		}

		this.isDeviceOn = isDeviceOnTemp;
		this.displayDeviceErrorIcon = displayDeviceErrorIconTemp;
		this.displayCommunicationErrorIcon = displayCommunicationErrorIconTemp;
		this.displayFilterSignIcon = displayFilterSignIconTemp;
		this.displayCoolHeatMasterIcon = displayCoolHeatMasterIconTemp;
		this.displayOffTimerIcon = displayOffTimerIconTemp;
		this.batteryLevelValue = batteryLevelValueTemp;
	}

	render() {
		let img_width = this.props.cell_width / 3;
		let temp_img_width = (0.1) * this.props.cell_width;
		let icon = getIcon(this.props.point_info.icon);

		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';

		let iconAlign = ((img_width / 2.5) + 10);

		let rightSubIconsAlign = (this.props.size * 5) + 35;

		this.handleCheckDeviceStatus();

		return (
			<div>
				<div style={{ textAlign: 'left' }}>
					<div style={this.isDeviceOn ?
						{ textAlign: 'center', marginLeft: -5, width: img_width + 30, height: img_width + 30, display: 'inline-block', backgroundImage: background_gradient, borderRadius: 35, position: 'absolute', zIndex: '-1' } :
						{ textAlign: 'center', marginLeft: -5, width: img_width + 30, height: img_width + 30, display: 'inline-block', backgroundImage: null, borderRadius: 35 }}>
						<img src={icon} style={{ width: img_width, paddingTop: 15 }} />
						<div style={{ position: 'absolute' }}>
							<img src={communication_error_icon} style={{ width: temp_img_width, position: 'absolute', top: -(iconAlign * 2), left: 5, visibility: this.displayCommunicationErrorIcon ? 'visible' : 'hidden', zIndex: '10' }} />
							<img src={device_error_icon} style={{ width: temp_img_width, position: 'absolute', top: -iconAlign, left: 5, visibility: this.displayDeviceErrorIcon ? 'visible' : 'hidden', zIndex: '10' }} />
							<img src={ch_master_icon} style={{ width: temp_img_width, position: 'absolute', top: -(iconAlign * 2), left: rightSubIconsAlign, visibility: this.displayCoolHeatMasterIcon ? 'visible' : 'hidden', zIndex: '10' }} />
							<img src={filter_icon} style={{ width: temp_img_width, position: 'absolute', top: -iconAlign, left: rightSubIconsAlign, visibility: this.displayFilterSignIcon ? 'visible' : 'hidden', zIndex: '10' }} />
							<img src={off_timer_icon} style={{ width: temp_img_width, position: 'absolute', top: 0, left: 5, visibility: this.displayOffTimerIcon ? 'visible' : 'hidden', zIndex: '10' }} />
							<img src={this.batteryLevelValue} style={{ width: temp_img_width, position: 'absolute', top: 0, left: rightSubIconsAlign, visibility: this.batteryLevelValue == null ? 'hidden' : 'visible', zIndex: '10' }} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}